<template>
  <b-col id="sidebarContainer" cols="4" class="d-flex flex-column mh-100" :style="style">
    <SideBar v-if="appLoaded" class="vertical-scroll" />
    <Spinner v-else data-test="loading-spinner" />
    <OrbVizLegal class="p-1 px-3" />
  </b-col>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import Spinner from '@/components/public/Spinner.vue'
import SideBar from '@/components/public/SideBar.vue'
import OrbVizLegal from '@/components/admin/OrbVizLegal.vue'
import { StoryKeys } from '@/types'

const components = {
  Spinner,
  SideBar,
  OrbVizLegal,
}

@Component({ components })
export default class SidePanel extends Vue {
  get appLoaded() {
    return this.$typedStore.activeVisualisation.appLoaded
  }

  get activeTab() {
    return this.$typedStore.public.display.activeTab
  }

  get path() {
    let path: string | undefined
    if (this.$typedStore.activeVisualisation.isPrimaryApp || this.originalTabColours) {
      path = this.activeTab?.path
    } else if (this.$typedStore.activeVisualisation.isSecondaryApp) {
      path = this.activeTab?.secondaryAppPath
    }
    return path ?? this.$typedStore.public.display.storyPath.toString()
  }

  get originalTabColours() {
    return this.$typedStore.primary.app.config.appConfig.originalTabColours
  }

  get isActiveTabForSecondaryApp() {
    return this.activeTab?.secondaryAppPath
  }

  get appForColours() {
    return this.originalTabColours && this.isActiveTabForSecondaryApp
      ? this.$typedStore.secondary
      : this.$typedStore.primary
  }

  get style() {
    const storyBackground = this.appLoaded
      ? this.appForColours.entities.nodes.colour(this.path)
      : this.originalTabColours
      ? this.activeTab?.barColour
      : this.activeTab?.colour

    const storyForeground = this.appLoaded
      ? this.appForColours.app.tabFontColor(this.path, StoryKeys.SIDEBAR_BOT)
      : this.activeTab?.tabFontColor

    return {
      '--story-background': storyBackground,
      '--story-foreground': storyForeground,
    }
  }
}
</script>

<style scoped>
#sidebarContainer {
  z-index: 2;
  box-shadow: 0 0 10px 0 #252525;
  color: var(--story-foreground);
  background: var(--story-background);
}
</style>
